import { useEffect, useState } from "react";
import axios from "axios";

const RANGOS = [
    { valor: "hoy",    etiqueta: "Hoy" },
    { valor: "7d",     etiqueta: "7 días" },
    { valor: "30d",    etiqueta: "30 días" },
    { valor: "90d",    etiqueta: "90 días" },
    { valor: "anio",   etiqueta: "Este año" },
    { valor: "todo",   etiqueta: "Todo" },
];


const ICOS_ACTIVIDAD = {
    usuario:    { icono: "bi-person-plus-fill",  bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)" },
    servicio:   { icono: "bi-grid-fill",         bg: "rgba(var(--violeta-bootstrap-rgb), 0.1)",  color: "var(--violeta-bootstrap)" },
    reserva:    { icono: "bi-calendar2-check",   bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado)" },
    venta:      { icono: "bi-cash-coin",         bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)" },
    completado: { icono: "bi-check-circle-fill", bg: "rgba(var(--cian-bootstrap-rgb), 0.1)",  color: "var(--cian-bootstrap)" },
    valoracion: { icono: "bi-star-fill",         bg: "rgba(var(--naranja-mapa-rgb), 0.1)",  color: "var(--naranja-mapa)" },
};

function formatearMoneda(valor) {
    return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(valor);
}

function formatearNumero(valor) {
    return new Intl.NumberFormat("es-CO").format(valor);
}

// La app (Flutter) manda nombres de ruta (ver lib/main.dart, cada pantalla tiene un `id`
// fijo), no URLs con slug — así que no se puede resolver el servicio/categoría exacto ahí,
// solo la pantalla genérica.
const ETIQUETAS_APP = {
    home: "Home",
    homeusuario: "Home (vendedor)",
    ComoFunciona: "Cómo funciona",
    Categorias: "Explorando categoría",
    Busqueda: "Buscando servicios",
    mapaPantallaCompleta: "Viendo el mapa",
    Referido: "Página de referido",
    Links: "Links",
    Servicio: "Viendo un servicio",
    Reserva: "Reservando",
    UsuarioServicios: "Servicios del vendedor",
    Notificaciones: "Sus notificaciones",
    Pago: "Pagando",
    RespuestaPago: "Confirmando pago",
    PagosComprador: "Sus pagos",
    Favoritos: "Sus favoritos",
    Perfil: "Su perfil",
    ReservasComprador: "Sus reservas",
    ReservaIndividualComprador: "Detalle de reserva",
    PagoIndividualComprador: "Detalle de pago",
    MisServicios: "Panel de vendedor",
    PagosVendedor: "Pagos (vendedor)",
    ReservaIndividualVendedor: "Detalle de reserva (vendedor)",
    ReservasVendedor: "Reservas (vendedor)",
    CrearEditarServicio: "Creando/editando servicio",
    CambiarContra: "Cambiando contraseña",
    RecuperarContra: "Recuperando contraseña",
    iniciarsesion: "Iniciando sesión",
    registrar: "Registrándose",
};

// Traduce la sesión activa (pathname/nombre de ruta + nombre real resuelto en backend, si
// aplica) a algo legible en el panel de "activos ahora".
function etiquetaPagina(s) {
    const p = (s?.pagina || "").toString();

    if (s?.origen === "app") {
        if (s?.nombreServicio) return `Viendo: ${s.nombreServicio}`;
        return ETIQUETAS_APP[p] || p || "Navegando";
    }

    if (p.startsWith("/servicio/") && s?.nombreServicio) return `Viendo: ${s.nombreServicio}`;
    if (p.startsWith("/categoria") && s?.nombreCategoria) return `Categoría: ${s.nombreCategoria}`;
    if (p === "/") return "Home";
    if (p.startsWith("/busqueda")) return "Buscando servicios";
    if (p.startsWith("/categoria")) return "Explorando categoría";
    if (p.startsWith("/servicio/")) return "Viendo un servicio";
    if (p.startsWith("/reserva")) return "Reservando";
    if (p.startsWith("/pago") || p.startsWith("/respuesta-pago")) return "Pagando";
    if (p.startsWith("/vendedor")) return "Panel de vendedor";
    if (p.startsWith("/usuario")) return "Su cuenta";
    if (p.startsWith("/iniciar-sesion") || p.startsWith("/registrar")) return "Iniciando sesión";
    return p || "Navegando";
}

function haceCuanto(fecha) {
    if (!fecha) return "";
    const segundos = Math.max(0, Math.floor((Date.now() - new Date(fecha).getTime()) / 1000));
    if (segundos < 60) return "hace unos segundos";
    return `hace ${Math.floor(segundos / 60)} min`;
}

function DashboardAdmin() {

    const [rango, setRango] = useState("hoy");
    const [totalUsuarios, setTotalUsuarios] = useState(null);
    const [totalServicios, setTotalServicios] = useState(null);
    // Este dato es con token firebase — usuarios registrados con la app activa, no instalaciones brutas
    const [totalServiciosBorrador, setTotalServiciosBorrador] = useState(null);
    const [instalacionesAndroid, setInstalacionesAndroid] = useState(null);
    const [instalacionesIOS, setInstalacionesIOS] = useState(null);
    const [ventasTotales, setVentasTotales]               = useState(null);
    const [comisiones, setComisiones]                     = useState(null);
    const [retencionFuente, setRetencionFuente]           = useState(null);
    const [pagosTerceros, setPagosTerceros]               = useState(null);
    const [gananciaNeta, setGananciaNeta]                 = useState(null);
    const [descuentoPrimeraCompra, setDescuentoPrimeraCompra]           = useState(null);
    const [countConDescuento, setCountConDescuento]                     = useState(null);
    const [comisionesSinDescuento, setComisionesSinDescuento]           = useState(null);
    const [reservasConfirmadas, setReservasConfirmadas]   = useState(null);
    const [actividadReciente, setActividadReciente] = useState(null);
    const [topCategorias, setTopCategorias] = useState(null);

    // Embudo estilo Shopify, 5 etapas: viendo la web / viendo servicio / agregado al carrito / reserva iniciada / compraron
    const [activosAhora, setActivosAhora] = useState(null);
    const [activosWeb, setActivosWeb] = useState(null);
    const [activosApp, setActivosApp] = useState(null);
    const [viendoServicioAhora, setViendoServicioAhora] = useState(null);
    const [viendoServicioWeb, setViendoServicioWeb] = useState(null);
    const [viendoServicioApp, setViendoServicioApp] = useState(null);
    const [agregadosCarrito, setAgregadosCarrito] = useState(null);
    const [agregadosCarritoWeb, setAgregadosCarritoWeb] = useState(null);
    const [agregadosCarritoApp, setAgregadosCarritoApp] = useState(null);
    const [reservaIniciada, setReservaIniciada] = useState(null);
    const [reservaIniciadaWeb, setReservaIniciadaWeb] = useState(null);
    const [reservaIniciadaApp, setReservaIniciadaApp] = useState(null);
    const [embudoComprados, setEmbudoComprados] = useState(null);
    const [compradosWeb, setCompradosWeb] = useState(null);
    const [compradosApp, setCompradosApp] = useState(null);
    const [sesionesActivas, setSesionesActivas] = useState(null);
    const [refrescarEmbudo, setRefrescarEmbudo] = useState(0);
    const [cargandoEmbudo, setCargandoEmbudo] = useState(false);

    // Datos fijos — no dependen del rango de fechas
    useEffect(() => {
        async function obtenerEstadisticasFijas() {
            try {
                const [resUsuarios, resServicios, resBorrador, resInstalaciones, resActividad, resCategorias] = await Promise.all([
                    axios.post("/obtener-usuarios-registrados"),
                    axios.post("/obtener-servicios-publicados"),
                    axios.post("/obtener-servicios-borrador"),
                    axios.post("/obtener-instalaciones-app"),
                    axios.post("/obtener-actividad-reciente"),
                    axios.post("/obtener-top-categorias"),
                ]);
                if (resUsuarios?.data?.exito)      setTotalUsuarios(resUsuarios.data.total);
                if (resServicios?.data?.exito)     setTotalServicios(resServicios.data.total);
                if (resBorrador?.data?.exito)      setTotalServiciosBorrador(resBorrador.data.total);
                if (resInstalaciones?.data?.exito) {
                    setInstalacionesAndroid(resInstalaciones.data.android);
                    setInstalacionesIOS(resInstalaciones.data.ios);
                }
                if (resActividad?.data?.exito)     setActividadReciente(resActividad.data.actividad);
                if (resCategorias?.data?.exito)    setTopCategorias(resCategorias.data.topCategorias);
            } catch (err) {
                console.log("Error obteniendo estadísticas fijas:", err);
            }
        }
        obtenerEstadisticasFijas();
    }, []);

    // Ventas y comisiones — se re-ejecutan cuando cambia el rango
    useEffect(() => {
        async function obtenerVentas() {
            setVentasTotales(null);
            setComisiones(null);
            setRetencionFuente(null);
            setPagosTerceros(null);
            setGananciaNeta(null);
            setReservasConfirmadas(null);
            setDescuentoPrimeraCompra(null);
            setCountConDescuento(null);
            setComisionesSinDescuento(null);
            try {
                const [resVentas, resReservas] = await Promise.all([
                    axios.post("/obtener-ventas-comisiones", { params: { rango } }),
                    axios.post("/obtener-reservas-confirmadas", { params: { rango } }),
                ]);
                if (resVentas?.data?.exito) {
                    setVentasTotales(resVentas.data.ventasTotales);
                    setComisiones(resVentas.data.comisiones);
                    setRetencionFuente(resVentas.data.retencionFuente);
                    setPagosTerceros(resVentas.data.pagosTerceros);
                    setGananciaNeta(resVentas.data.gananciaNeta);
                    setDescuentoPrimeraCompra(resVentas.data.descuentoPrimeraCompra);
                    setCountConDescuento(resVentas.data.countConDescuentoPrimeraCompra);
                    setComisionesSinDescuento(resVentas.data.comisionesSinDescuento);
                }
                if (resReservas?.data?.exito) setReservasConfirmadas(resReservas.data.total);
            } catch (err) {
                console.log("Error obteniendo ventas y comisiones:", err);
            }
        }
        obtenerVentas();
    }, [rango]);

    // Embudo de 5 etapas + lista de sesiones activas — "activos ahora"/"viendo servicio"/sesiones se
    // refrescan solos cada 30s para que se sientan en vivo; agregadosCarrito/reservaIniciada/comprados
    // dependen del rango seleccionado.
    useEffect(() => {
        let cancelado = false;

        async function obtenerEmbudo({ manual = false } = {}) {
            if (manual) setCargandoEmbudo(true);
            try {
                const [resEmbudo, resSesiones] = await Promise.all([
                    axios.post("/obtener-embudo-admin", { params: { rango } }),
                    axios.post("/obtener-sesiones-activas"),
                ]);
                if (cancelado) return;
                if (resEmbudo?.data?.exito) {
                    setActivosAhora(resEmbudo.data.activosAhora);
                    setActivosWeb(resEmbudo.data.activosWeb);
                    setActivosApp(resEmbudo.data.activosApp);
                    setViendoServicioAhora(resEmbudo.data.viendoServicioAhora);
                    setViendoServicioWeb(resEmbudo.data.viendoServicioWeb);
                    setViendoServicioApp(resEmbudo.data.viendoServicioApp);
                    setAgregadosCarrito(resEmbudo.data.agregadosCarrito);
                    setAgregadosCarritoWeb(resEmbudo.data.agregadosCarritoWeb);
                    setAgregadosCarritoApp(resEmbudo.data.agregadosCarritoApp);
                    setReservaIniciada(resEmbudo.data.reservaIniciada);
                    setReservaIniciadaWeb(resEmbudo.data.reservaIniciadaWeb);
                    setReservaIniciadaApp(resEmbudo.data.reservaIniciadaApp);
                    setEmbudoComprados(resEmbudo.data.comprados);
                    setCompradosWeb(resEmbudo.data.compradosWeb);
                    setCompradosApp(resEmbudo.data.compradosApp);
                }
                if (resSesiones?.data?.exito) setSesionesActivas(resSesiones.data.sesiones);
            } catch (err) {
                console.log("Error obteniendo embudo:", err);
            } finally {
                if (!cancelado && manual) setCargandoEmbudo(false);
            }
        }

        obtenerEmbudo({ manual: refrescarEmbudo > 0 });
        const intervalo = setInterval(obtenerEmbudo, 30000);
        return () => { cancelado = true; clearInterval(intervalo); };
    }, [rango, refrescarEmbudo]);

    const tarjetasFila1 = [
        {
            titulo:  "Usuarios registrados",
            valor:   totalUsuarios !== null ? formatearNumero(totalUsuarios) : "...",
            sub:     "total en la plataforma",
            icono:   "bi-people-fill",
            color:   "var(--azul-bootstrap-cta)",
            bgColor: "rgba(var(--azul-bootstrap-cta-rgb), 0.08)",
        },
        {
            titulo:  "Servicios publicados",
            valor:   totalServicios !== null ? formatearNumero(totalServicios) : "...",
            sub:     "total aprobados en la plataforma",
            icono:   "bi-grid-fill",
            color:   "var(--violeta-bootstrap)",
            bgColor: "rgba(var(--violeta-bootstrap-rgb), 0.08)",
        },
        {
            titulo:  "Servicios en borrador",
            valor:   totalServiciosBorrador !== null ? formatearNumero(totalServiciosBorrador) : "...",
            sub:     "pendientes de publicar",
            icono:   "bi-pencil-square",
            color:   "var(--dorado)",
            bgColor: "rgba(var(--amarillo-warning-rgb), 0.12)",
        },
    ];

    const tarjetasFila2 = [
        {
            titulo:  "Usuarios iOS activos",
            valor:   instalacionesIOS !== null ? formatearNumero(instalacionesIOS) : "...",
            sub:     "con token Firebase activo",
            icono:   "bi-apple",
            color:   "var(--gris-oscuro-bs)",
            bgColor: "rgba(var(--gris-oscuro-bs-rgb), 0.08)",
        },
        {
            titulo:  "Usuarios Android activos",
            valor:   instalacionesAndroid !== null ? formatearNumero(instalacionesAndroid) : "...",
            sub:     "con token Firebase activo",
            icono:   "bi-android2",
            color:   "var(--verde-bootstrap)",
            bgColor: "rgba(var(--verde-bootstrap-rgb), 0.08)",
        },
        {
            titulo:  "Ventas totales",
            valor:   ventasTotales !== null ? formatearMoneda(ventasTotales) : "...",
            sub:     "reservas confirmadas y completadas",
            icono:   "bi-cash-stack",
            color:   "var(--cian-bootstrap)",
            bgColor: "rgba(var(--cian-bootstrap-rgb), 0.08)",
        },
        {
            titulo:  "Comisiones Zervicy",
            valor:   comisiones !== null ? formatearMoneda(comisiones) : "...",
            sub:     "comisión bruta, antes de retención y pagos a terceros",
            icono:   "bi-percent",
            color:   "var(--naranja-mapa)",
            bgColor: "rgba(var(--naranja-mapa-rgb), 0.08)",
        },
        {
            titulo:  "Reservas confirmadas",
            valor:   reservasConfirmadas !== null ? formatearNumero(reservasConfirmadas) : "...",
            sub:     "compradas y pendientes de completar",
            icono:   "bi-calendar2-check",
            color:   "var(--azul-bootstrap-cta)",
            bgColor: "rgba(var(--azul-bootstrap-cta-rgb), 0.08)",
        },
        {
            titulo:  "Descuentos 1ra compra",
            valor:   descuentoPrimeraCompra !== null ? formatearMoneda(descuentoPrimeraCompra) : "...",
            sub:     countConDescuento !== null ? `${formatearNumero(countConDescuento)} reserva${countConDescuento !== 1 ? "s" : ""}` : null,
            icono:   "bi-gift-fill",
            color:   "var(--verde-bootstrap)",
            bgColor: "rgba(var(--verde-bootstrap-rgb), 0.08)",
        },
    ];

    return (
        <div className="container-fluid">

            {/* Título + selector de rango */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center gap-3 pt-3 pb-2 mb-4 border-bottom">
                <div>
                    <h1 className="h2 text-dark mb-1">Dashboard</h1>
                    <p className="text-secondary mb-0">Resumen general de la plataforma</p>
                </div>

                {/* Selector de rango */}
                <div className="card border-0 shadow-sm rounded-4 p-1">
                    <div className="d-flex gap-1">
                        {RANGOS.map((r) => {
                            const activo = rango === r.valor;
                            return (
                                <button
                                    key={r.valor}
                                    type="button"
                                    onClick={() => setRango(r.valor)}
                                    className={`btn btn-sm rounded-3 fw-semibold px-3 ${activo ? "btn-primary" : "btn-light text-secondary border-0"}`}
                                    style={{ fontSize: "0.82rem", transition: "all 0.15s" }}
                                >
                                    {r.etiqueta}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* EMBUDO EN VIVO (estilo Shopify), 5 etapas: viendo la web -> viendo servicio -> agregado al
                carrito -> reserva iniciada -> compra realizada. Las 2 primeras son en vivo (no dependen
                del rango); solo se calcula % entre etapas de la misma base (en vivo con en vivo, rango con
                rango) para no comparar cosas que no son comparables. */}
            {(() => {
                const pctVistosServicio = (activosAhora && viendoServicioAhora !== null && activosAhora > 0)
                    ? Math.round((viendoServicioAhora / activosAhora) * 100)
                    : null;
                const pctIniciaronReserva = (agregadosCarrito && reservaIniciada !== null && agregadosCarrito > 0)
                    ? Math.round((reservaIniciada / agregadosCarrito) * 100)
                    : null;
                const pctConversion = (reservaIniciada && embudoComprados !== null && reservaIniciada > 0)
                    ? Math.round((embudoComprados / reservaIniciada) * 100)
                    : null;

                const Etapa = ({ puntoVivo, etiqueta, valor, sub, color, web, app }) => (
                    <div className="flex-fill rounded-4 p-3" style={{ background: "var(--color-bg-surface-alt)", border: "1px solid var(--color-border)", minWidth: 180 }}>
                        <div className="d-flex align-items-center gap-2 mb-2">
                            {puntoVivo ? (
                                <span className="rounded-circle" style={{ width: 10, height: 10, background: color, boxShadow: `0 0 0 4px ${color}40`, flexShrink: 0 }}></span>
                            ) : (
                                <span className="rounded-circle" style={{ width: 10, height: 10, background: color, flexShrink: 0 }}></span>
                            )}
                            <span className="text-secondary text-uppercase fw-semibold" style={{ fontSize: 11, letterSpacing: 0.5 }}>{etiqueta}</span>
                        </div>
                        <div className="fw-bold text-dark" style={{ fontSize: "2.1rem", lineHeight: 1 }}>{valor}</div>
                        <div className="text-secondary mt-1" style={{ fontSize: 12 }}>{sub}</div>
                        <div className="d-flex align-items-center gap-3 mt-2 pt-2" style={{ borderTop: "1px solid var(--color-border)" }}>
                            <span className="text-secondary d-flex align-items-center gap-1" style={{ fontSize: 11 }}>
                                <i className="bi bi-window"></i>{web !== null && web !== undefined ? formatearNumero(web) : "..."} web
                            </span>
                            <span className="text-secondary d-flex align-items-center gap-1" style={{ fontSize: 11 }}>
                                <i className="bi bi-phone"></i>{app !== null && app !== undefined ? formatearNumero(app) : "..."} app
                            </span>
                        </div>
                    </div>
                );

                const Flecha = ({ porcentaje }) => (
                    <div className="d-flex flex-lg-column align-items-center justify-content-center gap-1 px-1" style={{ flexShrink: 0 }}>
                        <i className="bi bi-chevron-right d-none d-lg-inline text-secondary" style={{ fontSize: 20 }}></i>
                        <i className="bi bi-chevron-down d-inline d-lg-none text-secondary" style={{ fontSize: 20 }}></i>
                        {porcentaje !== null ? (
                            <span className="badge rounded-pill" style={{ background: "var(--color-bg-surface-alt)", color: "var(--color-text-primary)", fontSize: 11 }}>{porcentaje}%</span>
                        ) : null}
                    </div>
                );

                return (
                    <div className="card border-0 shadow-sm rounded-4 mb-3 overflow-hidden">
                        <div className="card-body p-4" style={{ background: "var(--color-bg-surface)" }}>
                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                                <h6 className="fw-bold text-dark mb-0">
                                    <i className="bi bi-lightning-charge-fill me-2" style={{ color: "#f1c40f" }}></i>
                                    Embudo en vivo
                                </h6>
                                <span className="text-secondary" style={{ fontSize: 12 }}>
                                    <i className="bi bi-arrow-repeat me-1"></i>
                                    "Viendo la web/servicio" se actualiza cada 30s · el resto según el rango seleccionado
                                </span>
                            </div>

                            <div className="d-flex flex-column flex-lg-row align-items-stretch gap-2">
                                <Etapa
                                    puntoVivo
                                    etiqueta="Viendo la web"
                                    valor={activosAhora !== null ? formatearNumero(activosAhora) : "..."}
                                    sub="navegando en este momento"
                                    color="#2ecc71"
                                    web={activosWeb}
                                    app={activosApp}
                                />
                                <Flecha porcentaje={pctVistosServicio} />
                                <Etapa
                                    puntoVivo
                                    etiqueta="Viendo un servicio"
                                    valor={viendoServicioAhora !== null ? formatearNumero(viendoServicioAhora) : "..."}
                                    sub="en la ficha de un servicio, ahora mismo"
                                    color="#3498db"
                                    web={viendoServicioWeb}
                                    app={viendoServicioApp}
                                />
                                <Flecha porcentaje={null} />
                                <Etapa
                                    etiqueta="Agregado al carrito"
                                    valor={agregadosCarrito !== null ? formatearNumero(agregadosCarrito) : "..."}
                                    sub="clic en 'Reservar' en el rango"
                                    color="#f1c40f"
                                    web={agregadosCarritoWeb}
                                    app={agregadosCarritoApp}
                                />
                                <Flecha porcentaje={pctIniciaronReserva} />
                                <Etapa
                                    etiqueta="Reserva iniciada"
                                    valor={reservaIniciada !== null ? formatearNumero(reservaIniciada) : "..."}
                                    sub="clic en 'Continuar a pagar' en el rango"
                                    color="#e67e22"
                                    web={reservaIniciadaWeb}
                                    app={reservaIniciadaApp}
                                />
                                <Flecha porcentaje={pctConversion} />
                                <Etapa
                                    etiqueta="Compra realizada"
                                    valor={embudoComprados !== null ? formatearNumero(embudoComprados) : "..."}
                                    sub="reservas confirmadas/completadas"
                                    color="#3fd67f"
                                    web={compradosWeb}
                                    app={compradosApp}
                                />
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* QUIÉN ESTÁ ACTIVO AHORA: página que ven + ciudad, se refresca cada 30s junto al embudo */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
                <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fw-bold text-dark mb-0">
                            <i className="bi bi-people-fill me-2" style={{ color: "#2ecc71" }}></i>
                            Quién está activo ahora
                        </h6>
                        <button
                            type="button"
                            className="btn btn-sm btn-light text-secondary border-0 d-flex align-items-center gap-1"
                            onClick={() => setRefrescarEmbudo((x) => x + 1)}
                            disabled={cargandoEmbudo}
                            style={{ fontSize: "0.8rem" }}
                        >
                            {cargandoEmbudo
                                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                : <i className="bi bi-arrow-clockwise"></i>}
                            Actualizar
                        </button>
                    </div>

                    {sesionesActivas === null ? (
                        <p className="text-secondary small mb-0">Cargando...</p>
                    ) : sesionesActivas.length === 0 ? (
                        <p className="text-secondary small mb-0">No hay nadie activo en este momento.</p>
                    ) : (
                        <div className="d-flex flex-column gap-2" style={{ maxHeight: 320, overflowY: "auto" }}>
                            {sesionesActivas.map((s, i) => {
                                const nombre = s.usuario
                                    ? (s.usuario.nombre || s.usuario.username || "Usuario")
                                    : "Invitado";
                                const ubicacion = [s.ciudad, s.pais].filter(Boolean).join(", ") || "Ubicación desconocida";

                                return (
                                    <div key={s._id || i} className="d-flex align-items-center gap-3 py-1">
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{ width: 34, height: 34, background: s.usuario ? "rgba(var(--azul-bootstrap-cta-rgb), 0.1)" : "rgba(var(--gris-oscuro-bs-rgb), 0.08)", overflow: "hidden" }}
                                        >
                                            {s.usuario?.avatar ? (
                                                <img src={s.usuario.avatar} alt={nombre} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                            ) : (
                                                <i className={`bi ${s.usuario ? "bi-person-fill" : "bi-incognito"}`} style={{ fontSize: "0.9rem", color: s.usuario ? "var(--azul-bootstrap-cta)" : "var(--gris-oscuro-bs)" }}></i>
                                            )}
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0 fw-semibold text-dark" style={{ fontSize: "0.88rem" }}>
                                                {nombre}
                                                <span className="text-secondary fw-normal ms-2" style={{ fontSize: "0.8rem" }}>{etiquetaPagina(s)}</span>
                                            </p>
                                            <p className="mb-0 text-secondary" style={{ fontSize: "0.78rem" }}>
                                                <i className="bi bi-geo-alt me-1"></i>{ubicacion}
                                            </p>
                                        </div>
                                        <span
                                            className="badge rounded-pill px-2 py-1 flex-shrink-0"
                                            style={{ background: s.origen === "app" ? "rgba(var(--violeta-bootstrap-rgb), 0.1)" : "rgba(var(--azul-bootstrap-cta-rgb), 0.1)", color: s.origen === "app" ? "var(--violeta-bootstrap)" : "var(--azul-bootstrap-cta)", fontSize: "0.7rem" }}
                                        >
                                            <i className={`bi ${s.origen === "app" ? "bi-phone" : "bi-window"} me-1`}></i>
                                            {s.origen === "app" ? "App" : "Web"}
                                        </span>
                                        <span className="text-secondary flex-shrink-0" style={{ fontSize: "0.75rem" }}>{haceCuanto(s.ultimaActividad)}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>

            {/* TARJETAS FILA 1 — 3 columnas */}
            <div className="row g-3 mb-3">
                {tarjetasFila1.map((t, i) => (
                    <div key={i} className="col-12 col-sm-6 col-xl-4">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-4">
                                <div className="mb-3">
                                    <div
                                        className="rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 48, height: 48, background: t.bgColor, flexShrink: 0 }}
                                    >
                                        <i className={`bi ${t.icono} fs-5`} style={{ color: t.color }}></i>
                                    </div>
                                </div>
                                <p className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.85rem" }}>{t.titulo}</p>
                                <h3 className="fw-bold text-dark mb-1">{t.valor}</h3>
                                <p className="text-secondary mb-0" style={{ fontSize: "0.82rem" }}>{t.sub}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* TARJETAS FILA 2 — 4 columnas */}
            <div className="row g-3 mb-4">
                {tarjetasFila2.map((t, i) => (
                    <div key={i} className="col-12 col-sm-6 col-xl">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body p-4">
                                <div className="mb-3">
                                    <div
                                        className="rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 48, height: 48, background: t.bgColor, flexShrink: 0 }}
                                    >
                                        <i className={`bi ${t.icono} fs-5`} style={{ color: t.color }}></i>
                                    </div>
                                </div>
                                <p className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.85rem" }}>{t.titulo}</p>
                                <h3 className="fw-bold text-dark mb-1">{t.valor}</h3>
                                <p className="text-secondary mb-0" style={{ fontSize: "0.82rem" }}>{t.sub}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* GANANCIA NETA REAL — desglose de qué se descuenta de la comisión bruta */}
            <div className="row g-3 mb-4">
                <div className="col-12">
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-1">
                                <i className="bi bi-wallet2 me-2 text-success"></i>
                                Ganancia neta real
                            </h6>
                            <p className="text-secondary mb-3" style={{ fontSize: "0.8rem" }}>
                                La comisión bruta no es lo que realmente nos queda — Wompi descuenta
                                retención en la fuente en cada cobro, y una comisión aparte por cada
                                desembolso enviado a un vendedor.
                            </p>

                            {descuentoPrimeraCompra !== null && (
                                <div className="d-flex align-items-center gap-2 rounded-3 mb-3 p-2" style={{ background: "rgba(var(--verde-bootstrap-rgb), 0.10)" }}>
                                    <i className="bi bi-gift-fill" style={{ color: "var(--verde-bootstrap)" }}></i>
                                    <span style={{ fontSize: "0.78rem", color: "var(--color-text-secondary)" }}>
                                        La comisión bruta de abajo ya tiene restados {formatearMoneda(descuentoPrimeraCompra)} en descuentos
                                        de primera compra ({formatearNumero(countConDescuento || 0)} reserva{countConDescuento !== 1 ? "s" : ""}).
                                        {descuentoPrimeraCompra > 0 && ` Sin ese descuento habría sido ${formatearMoneda(comisionesSinDescuento)}.`}
                                    </span>
                                </div>
                            )}

                            <div className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid var(--color-track-bg)" }}>
                                    <span className="text-dark" style={{ fontSize: "0.88rem" }}>Comisión bruta</span>
                                    <span className="fw-semibold text-dark">{comisiones !== null ? formatearMoneda(comisiones) : "..."}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid var(--color-track-bg)" }}>
                                    <span className="text-secondary" style={{ fontSize: "0.88rem" }}>
                                        − Retención en la fuente <span className="text-secondary" style={{ fontSize: "0.75rem" }}>(estimado, Wompi la descuenta del cobro)</span>
                                    </span>
                                    <span className="fw-semibold" style={{ color: "var(--rojo-600)" }}>
                                        {retencionFuente !== null ? `− ${formatearMoneda(retencionFuente)}` : "..."}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid var(--color-track-bg)" }}>
                                    <span className="text-secondary" style={{ fontSize: "0.88rem" }}>
                                        − Pagos a terceros <span className="text-secondary" style={{ fontSize: "0.75rem" }}>(comisión Wompi al desembolsar a vendedores)</span>
                                    </span>
                                    <span className="fw-semibold" style={{ color: "var(--rojo-600)" }}>
                                        {pagosTerceros !== null ? `− ${formatearMoneda(pagosTerceros)}` : "..."}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center pt-3">
                                    <span className="fw-bold text-dark">Ganancia neta real</span>
                                    <span className="fw-bold" style={{ fontSize: "1.15rem", color: "var(--verde-bootstrap)" }}>
                                        {gananciaNeta !== null ? formatearMoneda(gananciaNeta) : "..."}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FILA INFERIOR */}
            <div className="row g-3 mb-4">

                {/* Actividad reciente */}
                <div className="col-12 col-lg-7">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-3">
                                <i className="bi bi-activity me-2 text-primary"></i>
                                Actividad reciente
                            </h6>
                            <div className="d-flex flex-column gap-3">
                                {actividadReciente === null ? (
                                    <p className="text-secondary small mb-0">Cargando actividad...</p>
                                ) : actividadReciente.length === 0 ? (
                                    <p className="text-secondary small mb-0">Sin actividad reciente.</p>
                                ) : actividadReciente.map((a, i) => {
                                    const conf = ICOS_ACTIVIDAD[a.tipo] || ICOS_ACTIVIDAD.venta;
                                    const hace = a.fecha ? new Date(a.fecha).toLocaleString("es-CO", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "";
                                    return (
                                        <div key={i} className="d-flex align-items-center gap-3">
                                            <div
                                                className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                                style={{ width: 38, height: 38, background: conf.bg }}
                                            >
                                                <i className={`bi ${conf.icono}`} style={{ color: conf.color, fontSize: "0.9rem" }}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="mb-0 fw-semibold text-dark" style={{ fontSize: "0.88rem" }}>{a.descripcion}</p>
                                            </div>
                                            <span className="text-secondary flex-shrink-0" style={{ fontSize: "0.78rem" }}>{hace}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Top categorías */}
                <div className="col-12 col-lg-5">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-3">
                                <i className="bi bi-trophy-fill me-2 text-warning"></i>
                                Top categorías con más servicios
                            </h6>
                            <div className="d-flex flex-column gap-3">
                                {topCategorias === null ? (
                                    <p className="text-secondary small mb-0">Cargando categorías...</p>
                                ) : topCategorias.length === 0 ? (
                                    <p className="text-secondary small mb-0">Sin datos de categorías.</p>
                                ) : (() => {
                                    const maximo = topCategorias[0]?.total || 1;
                                    const colores = ["var(--azul-bootstrap-cta)","var(--violeta-bootstrap)","var(--verde-bootstrap)","var(--cian-bootstrap)","var(--naranja-mapa)"];
                                    return topCategorias.map((c, i) => (
                                        <div key={i}>
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <span className="fw-semibold text-dark" style={{ fontSize: "0.88rem" }}>
                                                    <span className="text-secondary me-2" style={{ fontSize: "0.78rem" }}>#{i + 1}</span>
                                                    {c.categoria}
                                                </span>
                                                <span className="fw-bold text-dark" style={{ fontSize: "0.88rem" }}>{formatearNumero(c.total)} serv.</span>
                                            </div>
                                            <div className="progress rounded-pill" style={{ height: 6, background: "var(--color-track-bg)" }}>
                                                <div
                                                    className="progress-bar rounded-pill"
                                                    style={{
                                                        width: `${Math.round((c.total / maximo) * 100)}%`,
                                                        background: colores[i] || "var(--gris-adb5bd)",
                                                        transition: "width 0.4s ease",
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default DashboardAdmin;
